module.exports = __webpack_public_path__ + "static/media/sc.ed506f5a.svg";